export default __webpack_public_path__ + "static/media/doubleeagle6.44e5530c.jpg";